"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnSgJpy = exports.EnSgEur = exports.EnSgUsd = exports.EnSgSgd = void 0;
class EnSgSgd {
    constructor() {
        this.locale = "en-sg";
        this.dateFormat = {
            short: "d/M/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd, d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "SGD",
            symbol: "SG$",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.EnSgSgd = EnSgSgd;
class EnSgUsd {
    constructor() {
        this.locale = "en-sg";
        this.dateFormat = {
            short: "d/M/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd, d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "US$",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.EnSgUsd = EnSgUsd;
class EnSgEur {
    constructor() {
        this.locale = "en-sg";
        this.dateFormat = {
            short: "d/M/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd, d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "EUR",
            symbol: "EUR",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.EnSgEur = EnSgEur;
class EnSgJpy {
    constructor() {
        this.locale = "en-sg";
        this.dateFormat = {
            short: "d/M/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd, d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "JPY",
            symbol: "JP¥",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.EnSgJpy = EnSgJpy;
